import { z } from 'zod';

/**
 * The two wire primitives every contract is built from.
 *
 * They live in their own module because the contracts form a dependency chain
 * - artifacts describe drops, the hunt reports them, and combining an artifact
 * answers with a hunt session - and a shared leaf is what keeps that chain a
 * chain rather than a cycle. Zod schemas are evaluated at module load, so a
 * cycle here is not a style problem: it is an undefined schema at import time.
 */

/**
 * A non-negative integer in canonical decimal.
 *
 * The 256-digit ceiling is a payload guard, NOT a level cap - it stops a
 * hostile request handing the parser a megabyte-long integer. Leading `+`,
 * leading zeros, whitespace, decimal points and scientific notation are all
 * rejected: each of them means something different from what it looks like.
 */
export const MAX_DECIMAL_FIELD_DIGITS = 256;

export const decimalStringSchema = z
  .string()
  .min(1)
  .max(MAX_DECIMAL_FIELD_DIGITS)
  .regex(/^(0|[1-9][0-9]*)$/, 'must be a canonical non-negative decimal');

/** Lowercase hex SHA-256, as produced by `sha256Hex`. */
export const digestSchema = z.string().regex(/^[0-9a-f]{64}$/);
